module.exports = __webpack_public_path__ + "img/logo.29f93b4f.png";